import { Redirect, Route, RouteProps } from 'react-router-dom';
import { Spinner } from '@hqo/react-components-library/dist/atoms/spinner';
import { defaultTheme } from '@hqo/react-components-library/dist/molecules/theme';

import { Container } from 'hocs/shared-styles';
import React from 'react';
import { hasToken } from 'store/user/selectors';
import { useCurrentUser } from 'hooks/use-current-user.hook';
import { useSelector } from 'react-redux';

interface PrivateRouteProps extends RouteProps {
  redirectTo?: string;
}
export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  redirectTo = '/error',
  ...routeProps
}: PrivateRouteProps): JSX.Element | null => {
  const [currentUser, loading] = useCurrentUser();
  const isTokenStored = useSelector(hasToken);

  if (currentUser) {
    return <Route {...routeProps} />;
  }

  if (!isTokenStored && !loading) {
    return <Redirect to={redirectTo} />;
  }

  return (
    <Container isLoading>
      <Spinner size="10em" color={defaultTheme.colors.$greyLight} />
    </Container>
  );
};
